define(function (require) {
	const ViewManager = require('civicsUtils/view_manager');
	const tpl = require('civicsViews/InviteApplicant/templates/t_itv_invite_applicant.hbs');
	const code_definition_collection = require('civicsCollections/code_definition_collection');
	const Utils = require('civicsUtils/general_utilities');
  	const Radio = require('backbone.radio');
	const AddInvitationChannel = Radio.channel('addInvitationChannel');
	const AvailableFeatures = require('civicsUtils/available_features');


	return Marionette.ItemView.extend({
		initialize: function (options) {
			this.config = options.config;
			this.requireCapacity = options.requireCapacity;
			this.additionalCapacityTypes = options.capacityCodes;
			this.applicantTypes = options.applicantTypes;
			this.showCapacity = options.showCapacity;
			this.showApplicantType = options.showApplicantType;
			this.instrumentType = options.instrumentType;
		},
		template: tpl,
		tagName: 'div',
		className: 'invitation-item list-row',
		attributes: {
			'role': 'row'
		},
		modelEvents: {
			change: 'render',
		},
		events: {
			'click @ui.removeButton': 'removeInvitationItem',
		},
		ui: {
			removeButton: '.remove-invitation',
			applicantTypeSelect: '.applicant-type',
			capacitySelect: '.capacity-type',
			email: '.send-to',
		},
		onShow: function () {
			this.setupFilterCodes(this.config.instrumentType);

		},
		onRender: function () {
			this.$el.rhythmCivicsTooltipInit();
			this.$el.rhythmThemeInitCivics();
			this.$el.rhythmThemeInit();
			
		},
		getData: function(primaryApplicant) {
				var data = Backbone.Syphon.serialize(this);
				data = _.extend(data,Utils.serializeDroppy(this.$el));
				data.sendTo = data.sendTo.trim();

				var prefixerror = {};
				prefixerror.validationError = {};
				var error = {};
				error.validationError = {};

				//Validate email
				var emailRegex = (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
				var email = data.sendTo;
				var maxEmailLength = AvailableFeatures.MaxEmailLength();

				data.isValid = true;
				if(_.isEmpty(email)){
					error.validationError['sendTo'] = i18n.t('CIVICS.COMMON_INVITE_APPLICANT.EMAIL_REQUIRED');
					data.isValid = false;
				}
				else if(!emailRegex.test(email)){
					error.validationError['sendTo'] = i18n.t('CIVICS.COMMON_INVITE_APPLICANT.INVALID_EMAIL');
					data.isValid = false;
				} else { //check emailLength, even though this shouldn't ever be possible with a maxlength on the field
					if(email.length > maxEmailLength){
						error.validationError['sendTo'] = i18n.t('CIVICS.ACCOUNT.EMAIL_LENGTH_ERROR', {max:maxEmailLength});
						data.isValid = false;
					}
				}

				if(data.capacity){
						let desc = Utils.civicsDropdownText(this.ui.capacitySelect);
						data.capacity = {code: data.capacity, description: desc};
				}
				else {
						let capacityCode = "";
						let capacityDesc = "";

						if(this.additionalCapacityTypes && this.additionalCapacityTypes.length == 1){
							capacityCode = this.additionalCapacityTypes[0].code;
							capacityDesc = this.additionalCapacityTypes[0].description;

						} else {
							if (this.showCapacity && this.requireCapacity) {
								error.validationError['capacity'] = i18n.t('CIVICS.COMMON_INVITE_APPLICANT.CAPACITY_REQUIRED');
								data.isValid = false;
						  }
						}

						data.capacity = {code:capacityCode,description:capacityDesc};
				}

				if (primaryApplicant) {
					var primaryApplicantType = primaryApplicant.get('applicantTypeDescription');
					var primaryApplicantCapacity = primaryApplicant.get('capacity') ? primaryApplicant.get('capacity') : '';
					var primaryApplicantEmailAddress = primaryApplicant.get('emailAddress');
					if (primaryApplicantType != 'undefined' && primaryApplicantType == data.applicantType &&
							primaryApplicantCapacity != 'undefined' && primaryApplicantCapacity == data.capacity.code &&
							primaryApplicantEmailAddress != 'undefined' && primaryApplicantEmailAddress == data.sendTo) {
								error.validationError['sendTo'] = i18n.t('CIVICS.COMMON_INVITE_APPLICANT.DUPLICATE_CONTACT');
								data.isValid = false;
							}
				}

				if(data.applicantType){
						let desc = Utils.civicsDropdownText(this.ui.applicantTypeSelect);
						data.applicantType = {code: data.applicantType, description: desc};
				}
				else {
						data.applicantType = {code:"",description:""};
						if (this.showApplicantType) {
							error.validationError['applicantType'] = i18n.t('CIVICS.COMMON_INVITE_APPLICANT.APPLICANT_TYPE_REQUIRED');
							data.isValid = false;
					  	}
					  	else {
						  //default the Applicant Type since it is technically required.
						  if(this.instrumentType.toLowerCase() == "tradelicense" || this.instrumentType.toLowerCase() == "businesslicense"){
							  data.applicantType = {code: 1};
						  } else {
							  data.applicantType = {code: 4};
						  }
					  }
					}

				if (!data.isValid) {
					ViewManager.errorToWindow(error, this, { skipFocus: true });
			  }

				return data;
		},
		removeInvitationItem: function () {
			this.triggerMethod('invitation-item:remove');
		},
		templateHelpers:function(){
      	var self = this;

			return {
				config: this.config,
				requireCapacity:this.requireCapacity,
        		applicantTypes: this.applicantTypes ? this.applicantTypes.toJSON() : '',
				additionalCapacityTypes: this.additionalCapacityTypes,
				showCapacity: (this.showCapacity && this.additionalCapacityTypes && this.additionalCapacityTypes.length > 1) ? true : false,
				showApplicantType: this.showApplicantType,
				maxEmailLength: AvailableFeatures.MaxEmailLength()
			}
		},
	});
});
